"use client";

import type { FilterContextValue, AdvancedFilterGroup } from "./types";
import { normalizeSerializedFilters } from "./utilities";

/**
 * Shape of raw serialized filters stored in saved views.
 * May be a flat filter map or a nested SerializedViewState.
 */
interface RawSavedViewFilters {
  filters?: Record<string, unknown>;
  advancedFilters?: AdvancedFilterGroup[];
  search?: string;
  [key: string]: unknown;
}

/**
 * Read a saved view's stored `filters` payload into FilterContext's filter state.
 * Accepts both the nested SerializedViewState format and the flat TableFilters format.
 */
export function parseViewFilters(
  savedView: { filters?: Record<string, unknown> },
  viewId: string
): FilterContextValue["filters"] {
  let simple: Record<string, unknown> = {};
  let advanced: AdvancedFilterGroup[] = [];
  let search = "";

  if (savedView.filters && Object.keys(savedView.filters).length > 0) {
    const rawFilters = savedView.filters as RawSavedViewFilters;
    if (rawFilters.filters && typeof rawFilters.filters === "object") {
      // SerializedViewState format: nested { filters, advancedFilters, search }
      simple = normalizeSerializedFilters(rawFilters.filters as Record<string, unknown>);
      advanced = rawFilters.advancedFilters ?? [];
      search = typeof rawFilters.search === "string" ? rawFilters.search : "";
    } else {
      // Flat TableFilters format
      simple = normalizeSerializedFilters(rawFilters as Record<string, unknown>);
    }
  }

  return { simple, advanced, search, activeViewId: viewId };
}
